import { CustomerModalSubmitActionType } from '../enums/customerModalSubmitActionType'

export const getIsSubmitActionTypeCreate = (submitActionType?: CustomerModalSubmitActionType): boolean =>
  submitActionType === CustomerModalSubmitActionType.Create
